<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a><a class="xref" href="#/chiheggie0006#toc">Abbreviations</a></h1>
<table style="border-bottom:0;">
<tbody><tr>
<td>
<p class="td"><span class="gt">AMEE</span> </p>
</td>
<td>
<p class="td">American Mount Everest Expedition (1963)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">AMREE</span> </p>
</td>
<td>
<p class="td">American Medical Research Expedition to Everest (1981)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">AMS</span> </p>
</td>
<td>
<p class="td">acute mountain sickness</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">BAS</span> </p>
</td>
<td>
<p class="td">British Antarctic Survey</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">DIPAS</span> </p>
</td>
<td>
<p class="td">(India) Defense Institute of Physiology and Allied Sciences</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">ECG</span> </p>
</td>
<td>
<p class="td">electrocardiogram</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">EPO</span> </p>
</td>
<td>
<p class="td">erythropoietin</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">FIDS</span> </p>
</td>
<td>
<p class="td">Falkland Islands Dependencies Survey (later BAS)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">IBEA</span> </p>
</td>
<td>
<p class="td">International Biomedical Expedition to the Antarctic (1980–81)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">IBP</span> </p>
</td>
<td>
<p class="td">International Biological Program (1964–74)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">ICAO</span> </p>
</td>
<td>
<p class="td">International Civil Aviation Organization</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">IGY</span> </p>
</td>
<td>
<p class="td">International Geophysical Year (1957–58)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">IMP</span> </p>
</td>
<td>
<p class="td">integrating motor pneumotachograph</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">INPHEXAN</span> </p>
</td>
<td>
<p class="td">International Physiological Expedition to Antarctica (1957)</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">IOC</span> </p>
</td>
<td>
<p class="td">International Olympic Committee</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">MRC</span> </p>
</td>
<td>
<p class="td">Medical Research Council</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">NIMR</span> </p>
</td>
<td>
<p class="td">(UK) National Institute of Medical Research</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">OEI, II, III</span> </p>
</td>
<td>
<p class="td">Operation Everest</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">ONR</span> </p>
</td>
<td>
<p class="td">(US) Office for Naval Research</p>
</td>
</tr>
<tr>
<td>
<p class="td"><a class="page" data-locator="p1"></a><span class="gt">P<sub>O</sub>₂, P<sub>CO</sub>₂</span> </p>
</td>
<td>
<p class="td">partial pressure of oxygen, carbon dioxide</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">RAF</span> </p>
</td>
<td>
<p class="td">(UK) Royal Air Force</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">RGS</span> </p>
</td>
<td>
<p class="td">(UK) Royal Geographical Society</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">SCAR</span> </p>
</td>
<td>
<p class="td">Scientific Committee on Antarctic Research</p>
</td>
</tr>
<tr>
<td>
<p class="td"><span class="gt">TAE</span> </p>
</td>
<td>
<p class="td">Commonwealth Trans-Antarctic Expedition (1955–58)</p>
</td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-heggie-0007.vue?24839854